import { InteractivityActionTypeValue } from '../InteractivityActionTypeValue';
import type { PlayStagedAnimationsInteractivityActionSnapshotOut } from './PlayStagedAnimationsInteractivityAction';

export const playStagedAnimationsInteractivityActionSnapshotMetadata = {
  typeId: InteractivityActionTypeValue.PlayStagedAnimations,

  innerInteractivityActions: {
    fromSnapshot(sn: PlayStagedAnimationsInteractivityActionSnapshotOut) {
      return sn.animations;
    },
  },
};
